import { Dialog, DialogContent, DialogID, useDialog } from '@components/Dialog';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

import { InviteValues } from './InviteValues';
import './styles.scss';

interface InviteDialogUIProps {
  dialogId: DialogID;
  onClose: () => void;
  appointmentId?: string;
  personLabel: string;
}

const InviteDialogUI = ({
  dialogId,
  onClose,
  appointmentId,
  personLabel,
}: InviteDialogUIProps) => (
  <Dialog
    id={dialogId}
    onClose={onClose}
    heading="Your appointment details"
    description="Share these details with your customer or supporting Partner so they can join your appointment:"
  >
    {appointmentId && (
      <DialogContent className="invite__content">
        <InviteValues code={appointmentId} personLabel={personLabel} />
      </DialogContent>
    )}
  </Dialog>
);

const InviteDialog = () => {
  const { appointment, personLabel } = useAppointmentContext();
  const dialog = useDialog(DialogID.APMT_INFO);

  return (
    <InviteDialogUI
      dialogId={dialog.id}
      onClose={() => dialog.setOpen(false)}
      appointmentId={appointment?.id}
      personLabel={personLabel}
    />
  );
};

export type { InviteDialogUIProps };

export { InviteDialog, InviteDialogUI };
